import AppNotices from '@/components/ui/AppNotices.vue'

const NoticeStore = {
  state: [],
  settings: {
    type: 'info'
  },
  setOptions (options) {
    this.settings = {...this.settings, ...options}
  },
  remove (timestamp) {
    let indexToDelete = -1
    let i = 0
    let len = this.state.length

    while (i < len) {
      let stateItem = this.state[i]
      if (stateItem.timestamp === timestamp) {
        indexToDelete = i
        break
      }

      i++
    }

    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1)
    }
  },
  clear () {
    this.state.splice(0)
  },
  add (notice) {
    if (typeof notification === 'string' || notice instanceof String) {
      notice = {text: notice}
    }
    notice.timestamp = new Date()
    notice.timestamp.setMilliseconds(notice.timestamp.getMilliseconds() + this.state.length)
    notice = {...this.settings, ...notice}

    this.state.push(notice)
  },
  notify (notice) {
    if (Array.isArray(notice)) {
      notice.forEach((noticeInstance) => {
        this.add(noticeInstance)
      })
    } else {
      this.add(notice)
    }
  }
}

const NoticesPlugin = {
  install (Vue, options) {
    Vue.mixin({
      data () {
        return {
          noticeStore: NoticeStore
        }
      },
      methods: {
        notify (notice, delay = null) {
          if (delay !== null) {
            if (notice instanceof Array) {
              notice = notice.map(note => {
                note.delay = delay
                return note
              })
            } else if (notice instanceof Object) {
              notice.delay = delay
            }
          }
          this.noticeStore.notify(notice)
        },
        info (text, delay = null) {
          const notice = { text: text, type: 'info' }
          this.notify(notice, delay)
        },
        success (text, delay = null) {
          const notice = { text: text, type: 'success' }
          this.notify(notice, delay)
        },
        error (text, delay = null) {
          const notice = { text: text, type: 'error' }
          this.notify(notice, delay)
        }
      }
    })
    Object.defineProperty(Vue.prototype, '$notify', {
      get () { return this.$root.notify }
    })
    Object.defineProperty(Vue.prototype, '$info', {
      get () { return this.$root.info }
    })
    Object.defineProperty(Vue.prototype, '$success', {
      get () { return this.$root.success }
    })
    Object.defineProperty(Vue.prototype, '$error', {
      get () { return this.$root.error }
    })
    Object.defineProperty(Vue.prototype, '$notices', {
      get () { return this.$root.noticeStore }
    })
    Vue.component('AppNotices', AppNotices)
    if (options) {
      NoticeStore.setOptions(options)
    }
  }
}

export default NoticesPlugin



// WEBPACK FOOTER //
// ./src/common/plugins/notice.js